<div class="side-menu">
  <div class="logo-container">
    <h2 class="logo">Admin Portal</h2>
  </div>

  <div *ngIf="loadingRole" class="menu-items">
    <div class="loading-spinner">Loading menu...</div>
  </div>

  <div *ngIf="!loadingRole" class="menu-items">
    <ng-container *ngFor="let item of menuItems">

      <ng-container *ngIf="item.submenus">
        <div class="menu-item-with-submenu">
          <div class="menu-item" (click)="toggleSubmenu(item.label)">
            <span class="menu-icon">{{ item.icon }}</span>
            <span class="menu-label">{{ item.label }}</span>
            <span class="dropdown-icon" [class.rotated]="openSubmenu === item.label">▼</span>
          </div>

          <div *ngIf="openSubmenu === item.label" class="submenu-container">
            <a *ngFor="let submenu of item.submenus"
               [routerLink]="submenu.route"
               routerLinkActive="active"
               class="submenu-item">
              <span class="submenu-icon">{{ submenu.icon }}</span>
              <span class="submenu-label">{{ submenu.label }}</span>
            </a>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!item.submenus">
        <a [routerLink]="item.route"
           routerLinkActive="active"
           class="menu-item">
          <span class="menu-icon">{{ item.icon }}</span>
          <span class="menu-label">{{ item.label }}</span>
        </a>
         <div *ngIf="item.label === 'Dashboard'" class="menu-divider"></div>
         <div *ngIf="item.label === 'Corporates'" class="menu-divider"></div>
         <div *ngIf="item.label === 'Users'" class="menu-divider"></div>
         <div *ngIf="item.label === 'Administrators'" class="menu-divider"></div>
         <div *ngIf="item.label === 'Reports'" class="menu-divider"></div>


      </ng-container>
    </ng-container>
  </div>

  <div class="menu-footer">
    <button class="sign-out-btn" (click)="signOut()">
      <span class="menu-icon">🚪</span>
      <span class="menu-label">Sign Out</span>
    </button>
  </div>
</div>